/**
 * Resolve ONLINE license for cloud AI features.
 */

import { isCloudDemoRuntime } from '../../shared/utils/publicDemoRuntime';
import { getDemoAgentLicense } from '../../shared/config/demoAgentLicense';

export async function resolveAgentLicense() {
  if (isCloudDemoRuntime()) {
    return getDemoAgentLicense();
  }

  let licenseStr = localStorage.getItem('qawaem_license');

  if (!licenseStr) {
    licenseStr = localStorage.getItem('license_key');
  }

  if (!licenseStr && window.electronAPI?.get) {
    try {
      const licenseData = await window.electronAPI.get('license');
      if (licenseData) {
        licenseStr = JSON.stringify(licenseData);
      }
    } catch {
      // no license in electron store
    }
  }

  if (!licenseStr) {
    console.warn('AI Agent: no license found');
    return null;
  }

  const license = JSON.parse(licenseStr);
  const licenseMode = license.licenseMode || license.mode;

  if (licenseMode !== 'ONLINE') {
    console.log(`AI Agent: ${licenseMode} mode — cloud AI disabled (requires ONLINE)`);
    return null;
  }

  return {
    companyId: license.companyId || license.company_id,
    licenseKey: license.key || license.license_key,
  };
}
